import { render, staticRenderFns } from "./GroupItemPage.vue?vue&type=template&id=3fff4f06&"
import script from "./GroupItemPage.vue?vue&type=script&lang=js&"
export * from "./GroupItemPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports